import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface AccountStatus {
  subscription: 'free' | 'pro' | 'premium' | 'expired';
  credits: {
    total: number;
    used: number;
    remaining: number;
    next_reset_at: string | null;
    plan: string;
  };
}

export const useAccountValidation = () => {
  const [accountStatus, setAccountStatus] = useState<AccountStatus | null>(null);
  const [loading, setLoading] = useState(true);

  const validateAccount = async () => {
    try {
      const { data, error } = await supabase.functions.invoke('validate-account');

      if (error) throw error;

      setAccountStatus(data);
      return data;
    } catch (error: any) {
      console.error('Account validation error:', error);
      toast.error('Failed to validate account status');
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    validateAccount();
  }, []);

  return {
    accountStatus,
    loading,
    refetch: validateAccount
  };
};